
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1257 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M402.209 798.932l-294.25-308.776-100.2 104.406 394.45 413.922 846.762-888.562-99.493-104.406-747.269 783.416z"}})])
          )
        }
      }
    